<template>
<div>
    <updateCardWindow :baseUrl="baseUrl" v-if="showCard" @CloseBox="showCard=false" @CardUpdateSuccess="ShowToastForCardUpdate"></updateCardWindow>
    <paymentWindow :baseUrl="baseUrl" :subscription="selectedSubscription" v-if="showPayment" @CloseBox="showPayment=false" @PaymentSuccess="ShowToastForPayment" @PaymentError="ShowToastForPaymentError"></paymentWindow>
    <confirm-cancel :baseUrl="baseUrl" :subtoCancel="subtoCancel" @CloseBox="cancelSubs = false;" @ShowToastForCancel="ShowToastForCancel" @ShowToastForCancelError="ShowToastForCancelError" v-if="cancelSubs" />
    <toast-window :message="toastMessage" v-if="showT" />
    <div class="portal-tab-div history" v-if="!isLoading">
        <div class="account-summary-div">
            <div class="therapy-subs-div">
                <div class="portal-summary-header">Current Therapies</div>

                <div class="order-div portal order-info" v-for="subs in subscriptions" :key="subs.id">
                    <div class="div-block-960 new">
                        <div class="div-block-976"><img sizes="100vw" 
                                         :srcset="`https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/${getItemImage(subs.plan_name)}/1.webp 500w, https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/${getItemImage(subs.plan_name)}/1.webp 800w, https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/${getItemImage(subs.plan_name)}/1.webp 1080w`" 
                                         :alt="subs.plan_name" 
                                         :src="`https://ohmymeds.s3.us-east-2.amazonaws.com/public/assets/product_image/webp/${getItemImage(subs.plan_name)}/1.webp`" 
                                         loading="lazy" style="height:45px;width: 45px;">
                            <div>
                                <div class="product-name-2 portal">{{subs.plan_name}}<br></div>
                                <div class="text-block-850">Next Payment: {{subs.next_billing_date.split("T")[0]}}</div>
                            </div>
                        </div>
                        <div class="div-block-1778">
                            <div class="item-price-text">${{ parseFloat(subs.amount).toFixed(2) }}</div>
                            <div class="text-block-849" v-if="subs.payment_terms==12">Billed Yearly</div>
                            <div class="text-block-849" v-else-if="subs.payment_terms==6">Billed Semiannual</div>
                            <div class="text-block-849" v-else-if="subs.payment_terms==3">Billed Quaterly</div>
                            <div class="text-block-849" v-else>Billed Monthly</div>
                            <div class="past-due-text" v-if="subs.status==='paused'">Past Due</div>
                        </div>
                    </div>
                    <a href="#" class="link-51" @click.prevent="setSubscriptionToCancel(subs)" v-if="subs.status==='active' && shouldShowCancelButton(subs)">Cancel Subscription</a>
                    <a href="#" class="link-51" v-else-if="subs.status==='ended'">Cancelled</a>
                </div>
                <div class="button-container">
                    <div class="div-block-1117 b div-block-1847 portal button-wrapper">
                        <div class="div-block-1120">
                            <a href="#" class="button-44 w-button" @click.prevent="showCard=true" style="color:#fff; width: 100%;">Update Credit Card</a>
                        </div>
                    </div>
                    <div class="div-block-1117 b div-block-1847 portal button-wrapper" v-if="subscriptions.some(sub => sub.status === 'paused')">
                        <div class="div-block-1120">
                            <a href="#" class="button-44 w-button" @click.prevent="openPaymentModal(subscriptions.find(sub => sub.status === 'paused'))" style="color:#fff; background-color: #ff4c46; border: 1px solid #ff4c46; width: 100%;">Pay Now</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Payment History Section - Full Width Below -->
        <div class="payment-history-section">
            <div class="portal-summary-header">Past Payments</div>
            <div class="transaction-table-container">
                <table class="transaction-table" v-if="transactionItems.length > 0">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th class="desktop-only">Product</th>
                            <th>Receipt</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="trans in transactionItems" :key="`trans-${trans.id}`" class="transaction-row">
                            <td class="transaction-date">{{ trans.created_at.split("T")[0] }}</td>
                            <td class="transaction-amount">${{ parseFloat(trans.amount).toFixed(2) }}</td>
                            <td class="transaction-status">
                                <span :class="['status-badge', trans.status === 'success' ? 'status-success' : 'status-failed']">
                                    {{ trans.status }}
                                </span>
                            </td>
                            <td class="transaction-product desktop-only">{{ trans.product_name || 'Subscription' }}</td>
                            <td class="transaction-receipt">
                                <a href="#" v-if="trans.status==='success'" @click.prevent="downloadInvoice(trans.transaction_id,trans.product_name)" class="receipt-link">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    <span class="desktop-only">Download</span>
                                </a>
                                <span v-else class="no-receipt">-</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="no-transactions">
                    <p>No payment history found.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="loading-container" v-if="isLoading">
        <div class="loading-spinner">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#007bff" stroke-width="8" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                </circle>
            </svg>
            <div class="loading-text">Loading billing information...</div>
        </div>
    </div>
</div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import updateCardWindow from './updateCardWindow.vue';
import paymentWindow from './paymentWindow.vue';
import confirmationWindow from './confirmationWindow.vue'
import tostWindow from './tostWindow.vue'
export default {
    name: 'HomePage',
    components: {
        updateCardWindow,
        paymentWindow,
        'confirm-cancel': confirmationWindow,
        'toast-window': tostWindow
    },
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            showCard: false,
            showPayment: false,
            selectedSubscription: null,
            subscriptions: [],
            transactionItems: [],
            cancelSubs: false,
            toastMessage: '',
            showT: false,
            subtoCancel: '',
            isLoading: false,
        }
    },

    computed: {},
    mounted() {
        this.getSubscriptions();
        this.getTransactions();
    },
    methods: {
        shouldShowCancelButton(subs) {
            if (!subs.next_billing_date) return false;

            const nextBillingDate = new Date(subs.next_billing_date);
            const today = new Date();
            const daysUntilBilling = Math.ceil((nextBillingDate - today) / (1000 * 60 * 60 * 24));

            return daysUntilBilling <= 7;
        },
        setSubscriptionToCancel(subs){
            this.subtoCancel = subs;
            this.cancelSubs = true;
        },
        openPaymentModal(subscription) {
            this.selectedSubscription = subscription;
            this.showPayment = true;
        },
        ShowToastForPayment() {
            this.toastMessage = "Payment processed successfully"
            this.showT = true;
            this.showPayment = false;
            this.getSubscriptions();
            this.getTransactions();
        },
        ShowToastForPaymentError(message) {
            this.toastMessage = `Payment Error: ${message}`
            this.showT = true;
            this.showPayment = false;
        },
        /**
         * Generates an invoice PDF on the frontend using transaction data
         * @param {string} transactionId - The transaction ID
         * @param {string} productName - The product name
         */
        async downloadInvoice(transactionId, productName) {
            try {
                // Find the transaction details
                const transaction = this.transactionItems.find(trans => trans.transaction_id === transactionId);
                if (!transaction) {
                    console.error('Transaction not found');
                    return;
                }

                // Generate invoice HTML
                const invoiceHtml = this.generateInvoiceHtml(transaction, productName);
                
                // Configure PDF generation options
                const options = {
                    margin: 10,
                    filename: `invoice-${transaction.transaction_id}.pdf`,
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        dpi: 300,
                        scale: 2,
                        letterRendering: true,
                        useCORS: true
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'portrait'
                    }
                };
                
                // Generate the PDF
                html2pdf().set(options).from(invoiceHtml).save();
                console.log("Invoice PDF generated successfully");
            } catch (error) {
                console.error('Error generating invoice:', error);
            }
        },

        /**
         * Generates HTML content for the invoice
         * @param {Object} transaction - Transaction details
         * @param {string} productName - Product name
         * @returns {string} HTML content for the invoice
         */
        generateInvoiceHtml(transaction, productName) {
           
            const transactionDate = new Date(transaction.created_at).toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            });
            
            return `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="utf-8">
                    <style>
                        * {
                            margin: 0;
                            padding: 0;
                            box-sizing: border-box;
                        }
                        body {
                            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                            line-height: 1.6;
                            color: #374151;
                            background: #ffffff;
                            padding: 60px 40px;
                        }
                        .invoice {
                            max-width: 800px;
                            margin: 0 auto;
                            background: white;
                        }
                        .invoice-title {
                            font-size: 36px;
                            font-weight: 300;
                            color: #1f2937;
                            margin-bottom: 40px;
                        }
                        .invoice-meta {
                            margin-bottom: 60px;
                        }
                        .invoice-meta div {
                            display: flex;
                            margin-bottom: 12px;
                        }
                        .meta-label {
                            width: 120px;
                            color: #374151;
                        }
                        .meta-value {
                            color: #1f2937;
                            flex: 1;
                        }
                        .company-section {
                            display: flex;
                            justify-content: space-between;
                            margin: 80px 0;
                        }
                        .company-info, .bill-to {
                            flex: 1;
                        }
                        .company-name {
                            font-size: 20px;
                            font-weight: 400;
                            color: #1f2937;
                            margin-bottom: 8px;
                        }
                        .address-line {
                            color: #374151;
                            line-height: 1.6;
                        }
                        .bill-to {
                            text-align: right;
                        }
                        .bill-to-title {
                            color: #374151;
                            margin-bottom: 12px;
                        }
                        .amount-due {
                            font-size: 28px;
                            font-weight: 300;
                            color: #1f2937;
                            margin: 60px 0;
                        }
                        .items-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 60px 0;
                        }
                        .items-table thead {
                            border-bottom: 2px solid #374151;
                        }
                        .items-table th {
                            padding: 16px 0;
                            text-align: left;
                            font-size: 14px;
                            font-weight: 500;
                            color: #374151;
                            text-transform: uppercase;
                        }
                        .items-table th:nth-child(2),
                        .items-table th:nth-child(3),
                        .items-table th:nth-child(4) {
                            text-align: right;
                        }
                        .items-table td {
                            padding: 20px 0;
                            color: #1f2937;
                            border-bottom: 1px solid #e5e7eb;
                        }
                        .items-table td:nth-child(2),
                        .items-table td:nth-child(3),
                        .items-table td:nth-child(4) {
                            text-align: right;
                        }
                        .summary {
                            margin-top: 40px;
                            text-align: right;
                        }
                        .summary-row {
                            display: flex;
                            justify-content: flex-end;
                            margin-bottom: 12px;
                        }
                        .summary-label {
                            width: 120px;
                            text-align: right;
                            margin-right: 40px;
                            color: #374151;
                        }
                        .summary-amount {
                            width: 100px;
                            text-align: right;
                            color: #1f2937;
                        }
                        .summary-total {
                            border-top: 1px solid #374151;
                            padding-top: 12px;
                            margin-top: 12px;
                        }
                    </style>
                </head>
                <body>
                    <div class="invoice">
                        <h1 class="invoice-title">Invoice</h1>
                        
                        <div class="invoice-meta">
                            <div>
                                <span class="meta-label">Invoice #</span>
                                <span class="meta-value">${transaction.transaction_id}</span>
                            </div>
                            <div>
                                <span class="meta-label">Date of issue</span>
                                <span class="meta-value">${transactionDate}</span>
                            </div>
                            <div>
                                <span class="meta-label">Date due</span>
                                <span class="meta-value">${transactionDate}</span>
                            </div>
                        </div>

                        <div class="company-section">
                            <div class="company-info">
                                <div class="company-name">OhMyMeds</div>
                                <div class="address-line">${process.env.VUE_APP_COMPANY_ADDRESS}</div>
                                <div class="address-line">${process.env.VUE_APP_COMPANY_CITY}, ${process.env.VUE_APP_COMPANY_STATE_ZIP}</div>
                            </div>
                            <div class="bill-to">
                                <div class="bill-to-title">Bill to: ${this.$store.getters.user?.first_name} ${this.$store.getters.user?.last_name}</div>
                                <div class="address-line">${this.$store.getters.user?.email || this.user.email}</div>
                                ${this.$store.getters.shipping?.address_line_1 || this.user.address ? `<div class="address-line">${this.$store.getters.shipping?.address_line_1 || this.user.address}</div>` : ''}
                                ${this.$store.getters.shipping?.address_line_2 ? `<div class="address-line">${this.$store.getters.shipping?.address_line_2}</div>` : ''}
                                ${(this.$store.getters.shipping?.city || this.$store.getters.shipping?.state || this.$store.getters.shipping?.zip || this.user.city || this.user.state || this.user.zip) ? `<div class="address-line">${this.$store.getters.shipping?.city || this.user.city || ''}, ${this.$store.getters.shipping?.state || this.user.state || ''} ${this.$store.getters.shipping?.zip || this.user.zip || ''}</div>` : ''}
                            </div>
                        </div>

                        <div class="amount-due">$${parseFloat(transaction.amount).toFixed(2)} USD due ${transactionDate}</div>

                        <table class="items-table">
                            <thead>
                                <tr>
                                    <th>DESCRIPTION</th>
                                    <th>QTY</th>
                                    <th>UNIT PRICE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>${productName || 'Subscription Service'}</td>
                                    <td>1</td>
                                    <td>$${parseFloat(transaction.amount).toFixed(2)}</td>
                                    <td>$${parseFloat(transaction.amount).toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="summary">
                            <div class="summary-row">
                                <div class="summary-label">Subtotal</div>
                                <div class="summary-amount">$${parseFloat(transaction.amount).toFixed(2)}</div>
                            </div>
                            <div class="summary-row">
                                <div class="summary-label">Paid</div>
                                <div class="summary-amount">$${parseFloat(transaction.amount).toFixed(2)}</div>
                            </div>
                            <div class="summary-row summary-total">
                                <div class="summary-label">Amount Due</div>
                                <div class="summary-amount">$0.00</div>
                            </div>
                        </div>
                    </div>
                </body>
                </html>
            `;
        },
        getSubscriptionPrice() {

            return 349;
        },
        getItemImage(id) {
            try {

                return id.toLowerCase()
            } catch (error) {
                return "med"
            }

        },
        ShowToastForCancel() {
            this.toastMessage = "Your subscription is cancelled."
            this.showT = true;
            this.cancelSubs = false;
        },
        ShowToastForCancelError(message) {
            this.toastMessage = `Error : ${message}`
            this.showT = true;
            this.cancelSubs = false;
        },
        ShowToastForCardUpdate() {
            this.toastMessage = "Billing details updated successfully"
            this.showT = true;
            this.showCard = false;
        },
        async getSubscriptions() {
            try {
                //const lastChecked = this.$store.getters.lastCheckedSubscription;
                //const ONE_HOUR = 60 * 60 * 1000;
                const shouldRefresh = true //!lastChecked || (Date.now() - parseInt(lastChecked)) > ONE_HOUR;

                if (shouldRefresh) {
                    this.isLoading = true;
                    const response = await this.$axios.get(`${this.baseUrl}/api/subscription-items`);
                    if (response.data.status === 'success') {
                        await this.$store.dispatch('updateSubscriptions', {
                            items: response.data.subscriptions,
                            timestamp: Date.now().toString()
                        });
                        this.subscriptions = response.data.subscriptions;
                    }
                } else {
                    this.subscriptions = this.$store.getters.subscriptionItems;
                }
            } catch (error) {
                console.error('Failed to fetch progress:', error);
            } finally {
                this.isLoading = false;
            }

        },

        async getTransactions() {
            try {
                
                    this.isLoading = true;
                    const response = await this.$axios.get(`${this.baseUrl}/api/transaction-items`);
                    if (response.data.status === 'success') {
                        await this.$store.dispatch('updateTransactionItems', {
                            items: response.data.transactions,
                            timestamp: Date.now().toString()
                        });
                        this.transactionItems = response.data.transactions;
                    }
                
            } catch (error) {
                console.error('Failed to fetch progress:', error);
            } finally {
                this.isLoading = false;
            }
        },
    },

    created() {

    }
}
</script>

<style scoped>
.payment-history-section {
    width: 100%;
    margin-top: 30px;
    padding: 0 20px;
}

.past-due-text {
    color: #ff4c46;
    font-weight: bold;
    font-size: 12px;
    margin-top: 5px;
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px;
    min-height: 200px;
}

.loading-spinner {
    text-align: center;
}

.loading-text {
    margin-top: 15px;
    font-size: 14px;
    color: #333;
}

.pay-now-link {
    color: #dc3545 !important;
    font-weight: bold;
}

.button-container {
    display: flex;
    gap: 10px;
}

.button-wrapper {
    flex: 1;
}

@media (max-width: 768px) {
    .button-container {
        flex-direction: column;
    }
    
    .button-wrapper {
        flex: none;
        width: 100%;
    }
    
    .desktop-only {
        display: none;
    }
    
    .payment-history-section {
        padding: 0 10px;
        margin-top: 20px;
    }
}

.transaction-table-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-top: 20px;
}

.transaction-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.transaction-table thead {
    background-color: #f8f9fa;
}

.transaction-table th {
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
}

.transaction-table td {
    padding: 12px 16px;
    border-bottom: 1px solid #dee2e6;
    vertical-align: middle;
}

.transaction-row:hover {
    background-color: #f8f9fa;
}

.transaction-row:last-child td {
    border-bottom: none;
}

.transaction-date {
    font-weight: 500;
    color: #495057;
}

.transaction-amount {
    font-weight: 600;
    color: #28a745;
}

.status-badge {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    text-transform: capitalize;
}

.status-success {
    background-color: #d4edda;
    color: #155724;
}

.status-failed {
    background-color: #f8d7da;
    color: #721c24;
}

.receipt-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #007bff;
    text-decoration: none;
    font-size: 13px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s ease;
}

.receipt-link:hover {
    background-color: #e7f3ff;
    color: #0056b3;
}

.no-receipt {
    color: #6c757d;
    font-style: italic;
}

.no-transactions {
    padding: 40px;
    text-align: center;
    color: #6c757d;
}

.no-transactions p {
    margin: 0;
    font-style: italic;
}
</style>
